export enum DisputesNotesEmailsFormLabelsEnum {
  EMAIL_SUCCESSFULL = 'Email was created successfully',
  EMAIL_FAILED = 'Email could not created',
  NOTE_SUCCESSFULL = 'Note was created successfully',
  NOTE_FAILED = 'Note could not created',
}
